import { CarrierModel } from '../../../../../common/models/carrier.model';
import { ControlProperty } from '../../../../../common/models/forms.model';
import { AddressModel } from '../../../../../common/models/address.model';

export class AllocationViewActionCarrierForm {
  constructor(
    model: CarrierModel,
    public address: ControlProperty<AddressModel> = model.address,
    public extId: ControlProperty<string> = model.extId,
    public id: ControlProperty<string> = model.id,
    public name: ControlProperty<string> = model.name,
    // eslint-disable-next-line id-blacklist
    public number: ControlProperty<string> = model.number,
  ) {}
}
